import AboutUs from "../components/aboutPage/AboutUs";

export default function About(){
    return(
        <AboutUs/>
    )
}